import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../assets/css/productwhychooseus.css';

const cards = [
  {
    image: require("../assets/images/why choose us/customizable_solutions.jpeg"),
    title: "Trusted Multi-Brand Dealer",
    description: "Premium solutions from industry leaders like Mitsubishi Electric, Blue Star, and Daikin, ensuring quality and reliability for your comfort needs.",
    
  },
  {
    image: require("../assets/images/why choose us/expert_installation_support.jpeg"),
    title: "Expert Installation & Support",
    description: "Our certified technicians provide professional installation, proactive maintenance, and 24/7 support to ensure your systems always perform at their best.",
  
  },
  {
    image: require("../assets/images/why choose us/trusted_multi_brand_dealer.jpeg"),
    title: "Customizable Solutions",
    description: "Tailored AC and ventilation solutions designed specifically for your space, whether residential, commercial, or industrial environments.",
   
  }
];

const ProductWhyChoose = () => {
  return (
    <section className="why-choose-section py-5">
      <Container>
        <Row className="justify-content-center mb-5">
          <Col md={8} className="text-center">
            <h2 className="section-title mb-3">Why Choose Breath Comfort?</h2>
          </Col>
        </Row>
        
        <Row>
          {cards.map((card, index) => (
            <Col md={4} key={index} className="mb-4">
              <Card className="why-choose-card h-100 shadow-sm">
                <div className="card-image-wrapper">
                  <img src={card.image} alt={card.title} className="card-img" />
                </div>
                <Card.Body className="text-center">
                  <Card.Title className="fw-bold mb-3">{card.title}</Card.Title>
                  <Card.Text>{card.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProductWhyChoose;